import { createContext, useContext } from 'react';
export const HttpClientContext = createContext(undefined);
export function useHttpClient() {
    const context = useContext(HttpClientContext);
    if (context === undefined) {
        throw new Error('useHttpClient must be used within a HttpClientProvider');
    }
    return context;
}

//# sourceMappingURL=http-client-context.js.map